export const LOTTIE_DYNAMIC_KEYS = {
    AMOUNT: "amount",
    SUBCOPY: "subcopy",
};

export const DINE_CASH_AMOUNT_FORMAT = "₹{0}";
export const DINE_CASH_SUBCOPY_FORMAT = "DineCash received out of ₹{0}";
export const DINE_CASH_SUBCOPY_MAX_REACHED_FORMAT = "DineCash received";

export const QR_CODE_ALT_TEXT = "DineCash QR Code";

export const DINE_CASH_POOLING_TITLE = "Ask friends to scan the QR code";
export const DINE_CASH_WHATSAPP_BUTTON_TEXT = "Or share WhatsApp link";
export const DINE_CASH_DONE_BUTTON_TEXT = "Done";
export const DINE_CASH_HOW_IT_WORKS_TITLE = "How it works";

export const ALL_TAB_NAME = "All";

export enum ScreenImpressionState {
    LIMIT_REACHED = "limit_reached",
    RECEIVED = "received",
    DEFAULT = "default",
}

export const POOLING_LEDGER_POPUP_TITLE = "DineCash received from {0} friend{1}";
